const coupon = {
  message: 'Der Coupon Code wurde gespeichert und wird nach Hinzufügen des Produktes in den Warenkorb angewendet.',
  toProduct: 'Zum Produkt',
  toProducts: 'Zu den Produkten',
  coupon: 'Coupon',
}

export default coupon
